<style lang="stylus">
.footer {
  background-color: #1e1e1e;

  .footer-lables {
    margin-left: 4rem;

    p {
      margin: 0;
    }
  }

  p {
    font-size: 14px;
    font-weight: 500;
  }
}

.pop {
  color: white;
  height: 45px;
  background-color: #525252;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.little-foot-hover {
  a {
    &:hover {
      text-decoration: underline !important;
    }
  }
}

.popup {
  color: white;
  background-color: #525252;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  padding: 25px;

  a {
    color: #fec627 !important;
    font-weight: bold;
  }
}

.popupWindow {
  font-weight: 500;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 50px;
}

@media screen and (max-width: 768px) {
  .popupWindow {
    bottom: 140px;
  }
}

.circle-fas {
  position: absolute;
  background-color: #fec627;
  border-radius: 50%;
  padding: 8px;
  margin: 4px;
}

footer {
  @media (min-width: @mobile-min) {
    &.login {
      position: fixed;
    }
  }

  width: 100%;
  bottom: 0;
  background-color: @background-color;

  #innovation-bar {
    background-color: #FFC627;

    .innovation-top {
      margin: 0 auto;
      max-height: 100px;

      a {
        border-bottom: 0;
        color: #000;
        font-size: x-large;
        font-weight: 700;
        text-decoration: none;

        @media only screen and (max-width: 768px) {
          font-size: large;
        }
      }

      .innovation-hidden {
        display: block !important;
        float: right;
        width: 150px !important;
        height: 0;
        margin-right: 5px;

        @media only screen and (max-width: 768px) {
          width: 110px !important;
        }
      }

      @media (min-width: 1200px) {
        width: 1170px;
      }
    }

    .innovation-status {
      text-align: inherit;
      // width: 'calc(%s - %s)' % (100% 12em) !important;
      display: inline-block;
      margin-bottom: 0.7em;
      margin-top: 0.7em;
      padding: 0 10px;

      a {
        font-size: 16px !important;
      }

      @media (min-width: 992px) {
        padding-right: 20px;
      }
    }

    @media (max-width: 600px) {
      .innovation-status {
        text-align: inherit;
        // width: 'calc(%s - %s)' % (129% 12em) !important;
        display: inline-block;
        margin-bottom: 0.7em;
        margin-top: 0.7em;
        padding: 0 1em;
      }
    }

    img {
      // border-style: none;
      // vertical-align: middle;
      // margin-top: -2.4em;
      // width: 150px;
      // position: relative;
      height: auto;
      // @media only screen and (max-width: 768px) {
      // margin-top: -75px;
      // width: 110px;
      // height: auto;
      // }
    }
  }

  .little-foot {
    padding-top: 10px;
    background-color: #e5e5e5;

    ul {
      -webkit-font-smoothing: antialiased;
      display: block;
      max-width: 100%;
      white-space: nowrap;
      margin: 0 auto;
      list-style: none;
      padding: 20px 15px;

      @media (min-width: 931px) {
        width: 730px;
      }

      @media (min-width: 992px) {
        width: 960px;
      }

      @media (min-width: 1200px) {
        width: 1170px;
      }
    }

    li {
      span {
        font-size: 14px;
      }

      display: block;
      margin-right: 20px;
      padding: 2px 0;
      color: @dark-gray3;

      @media (min-width: 768px) {
        display: inline;
        padding: 0;
      }

      a {
        &:hover {
          color: #666;
        }

        text-decoration: none;
        font-size: 14px;
        font-weight: 400;
        color: #191919;
        border: 0;
        white-space: nowrap;

        @media (min-width: 768px) {
          font-size: 14px;
        }
      }
    }
  }
}

.blackFooter {
  background-color: #191919;
  color: white;

  p.m0 {
    margin-bottom: 0px !important;
  }
}

.region {
  padding-top: 2.5rem;
}

.normal-weight {
  font-weight: normal;
}

@media (max-width: 600px) {
  .region {
    padding-top: 5.8em;
  }
}

@media (min-width: 1263px) {
  .lg-welcome-screen {
    display: none;
  }
}

.tab-view {
  @media (min-width: 750px) and (max-width: 900px) {
    justify-content: center;
    text-align: center;
  }
}

.social-icons {
}

.footer-hover:hover {
  color: #ffc627 !important;
  text-decoration: underline;
}

.v-expansion-panel__header {
  padding: 0 !important;
}

.footer-dropdown-mobile {
  padding: 8px 0 !important;
}
</style>
<template>
  <div>
    <!-- The following code was commented, because of the design changes -->
    <div style="text-align: center" v-if="shouldDisplayUndergradImg">
      <img
        :src="isEligibleToCreateLearner"
        :class="(route == 'WelcomeDesktop' || route == 'login') && isEligibleCreateLearner ? 'lg-welcome-screen' : ''"
        alt=""
      />
    </div>
    <v-container class="popupWindow" v-if="false">
      <v-row wrap>
        <v-col cols="12" sm="12" md="12" xl="10">
          <v-col v-if="isOpen" class="pop" cols="9" sm="6" md="3" xl="2">
            <v-row align-center justify-space-around row fill-height>
              <span>Questions?</span>
              <button style="align-items: right" @click="toggle()">
                <v-icon>mdi-chevron-up</v-icon>
              </button>
            </v-row>
          </v-col>
          <v-col v-if="!isOpen" class="popup" cols="10" sm="8" md="4" xl="4">
            <v-row align-start justify-end row fill-height>
              <button @click="toggle()">
                <v-icon style="padding-right: 17px">mdi-close</v-icon>
              </button>
            </v-row>
            <v-row align-start>
              <span style="font-size: 25px; padding-bottom: 12px">Questions?</span>
            </v-row>
            <v-row wrap>
              <span>Have any additional questions that we can help answer?</span>
              <span>
                Please email
                <a :href="href" target="_blank">{{ email }}</a>
                or call us at
                <a>{{ telephone }}.</a>
              </span>
            </v-row>
          </v-col>
        </v-col>
        <!-- <v-col md2>
        <v-btn class="mx-2" fab color="White">
          <v-icon>mdi-arrow-up</v-icon>
        </v-btn>
        </v-col>-->
      </v-row>
    </v-container>
    <!-- Actual footer are -->
    <footer style="background: #e8e8e8">
      <div class="blackFooter">
        <v-container class="py-6">
          <v-row align-center wrap>
            <!-- Left Side Logo -->
            <v-col cols="12" sm="4" class="pa-0">
              <img
                src="../assets/images/asu-ulc-logo-v2.svg"
                alt="Best Colleges U.S. News Most Innovative 2018"
                class="ae-img"
              />
            </v-col>

            <!-- Right Side Icons -->
            <v-col cols="12" sm="8" class="pa-0 d-flex justify-end align-center">
              <v-row no-gutters align="center" justify="end" class="d-none d-sm-flex">
                <v-spacer />
                <img
                  src="../assets/icons/facebook-square-brands.svg"
                  class="social-icons mr-4"
                  alt="facebook"
                  style="height: 24px"
                />
                <!-- </v-btn> -->
                <img
                  src="../assets/icons/linkedin-brands.svg"
                  class="social-icons mr-4"
                  alt="linkedin"
                  style="height: 24px"
                />
                <img
                  src="../assets/icons/instagram-square-brands.svg"
                  class="social-icons mr-4"
                  alt="instagram"
                  style="height: 24px"
                />

                <!-- Icons for Desktop -->
                <!-- <v-btn icon class="">
                  <v-icon>mdi-facebook</v-icon>
                </v-btn>
                <v-btn icon class="social-icons">
                  <v-icon>mdi-linkedin</v-icon>
                </v-btn>
                <v-btn icon class="social-icons">
                  <v-icon>mdi-instagram</v-icon>
                </v-btn> -->
              </v-row>

              <!-- Icons for Mobile -->
              <v-row row justify-left class="pt-6 d-flex d-sm-none">
                <img src="../assets/icons/facebook-square-brands.svg" class="social-icons mr-4" alt="facebook" />
                <img src="../assets/icons/linkedin-brands.svg" class="social-icons mr-4" alt="linkedin" />
                <img src="../assets/icons/instagram-square-brands.svg" class="social-icons mr-4" alt="instagram" />
              </v-row>
            </v-col>
          </v-row>
        </v-container>

        <v-divider dark class="mt-0 mb-4" />

        <v-container :class="[$vuetify.display.smAndDown ? 'py-4' : 'py-6']">
          <v-row row wrap class="">
            <v-col cols="12" md="3" class="pa-0 pr-4">
              <v-row column class="normal-weight">
                <v-col cols="12" class="pb-4 font-weight-bold">
                  {{ showUlcHeaderFooter ? 'ASU Universal Learner Courses' : 'Earned Admission' }}</v-col
                >
                <!-- <v-col> Have questions? We’ve got the answers. Ask away! </v-col>
                <v-col class="py-3 text-body-1" style="font-size: 16px">
                  <div>Business hours for phone and chat</div>
                  <div>Monday - Friday</div>
                  <div>7am - 6pm MST</div>
                </v-col>

                <v-col class="pb-3">
                  <v-col>
                    <a
                      style="color: white; text-decoration: underline"
                      target="_blank"
                      :href="href"
                      @click="asuoDataLayerClick('FooterComponent', '0', { text: email })"
                      >{{ email }}</a
                    >
                  </v-col>
                </v-col>

                <v-col :class="[xs ? 'pb-3' : 'pb-4']">
                  <a
                    style="color: white; text-decoration: underline"
                    :href="dial"
                    target="_blank"
                    @click="asuoDataLayerClick('FooterComponent', '1', { text: telephone.replace(/[^A-Z0-9]/gi, '') })"
                    >{{ telephone }}</a
                  >
                </v-col> -->

                <v-col :class="[xs ? 'mb-4' : '']">
                  <v-btn
                    :href="showUlcHeaderFooter ? 'https://ulc.asu.edu/contact-us/' : 'https://ea.asu.edu/contact/'"
                    target="_blank"
                    rounded
                    color="#fec627"
                    class="mx-0 font-weight-bold"
                  >
                    Contact us
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>

            <v-col
              v-for="item in showUlcHeaderFooter ? ulcBlackFooterContent : eaBlackFooterContent"
              :key="item.title"
              class="d-none d-md-flex"
            >
              <div>
                <p v-if="item.title" class="font-weight-bold mb-4">{{ item.title }}</p>
                <p v-if="!item.title">&nbsp;</p>
                <div v-for="child in item.children" :key="child.text" class="pb-2">
                  <a
                    @click="asuoDataLayerClick('FooterComponent', '2', { text: child.text })"
                    style="color: white"
                    class="subheading footer-hover"
                    :href="child.uri"
                    :target="child.uri.includes('http') ? '_blank' : ''"
                    >{{ child.text }}</a
                  >
                </div>
              </div>
            </v-col>

            <!-- Footer content Mobile -->
            <v-col cols="12" md="3" class="pa-0 d-flex d-md-none mr-3">
              <v-expansion-panels class="d-block" variant="accordion" dark>
                <template
                  v-for="(item, index) in showUlcHeaderFooter ? ulcBlackFooterContent : eaBlackFooterContent"
                  :key="index"
                >
                  <!-- If title exists, use expansion panel -->
                  <v-expansion-panel v-if="item.title" style="border-top: 1px solid #393939; background-color: #191919">
                    <v-expansion-panel-title style="color: white" class="px-0">
                      <div>{{ item.title }}</div>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text>
                      <v-card
                        v-for="(child, i) in item.children"
                        :key="`child-${i}`"
                        flat
                        style="background-color: #191919"
                      >
                        <v-card-text class="footer-dropdown-mobile">
                          <a
                            @click="asuoDataLayerClick('FooterComponent', '2', { text: child.text })"
                            style="color: white"
                            class="subheading footer-hover"
                            :href="child.uri"
                            :target="child.uri.includes('http') ? '_blank' : ''"
                          >
                            {{ child.text }}
                          </a>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-text>
                  </v-expansion-panel>

                  <!-- If no title, render children directly without expansion panel -->
                  <div v-else style="border-top: 1px solid #393939; background-color: #191919">
                    <v-card
                      v-for="(child, i) in item.children"
                      :key="`child-no-title-${i}`"
                      flat
                      style="background-color: #191919"
                    >
                      <v-card-text class="footer-dropdown-mobile">
                        <a
                          @click="asuoDataLayerClick('FooterComponent', '2', { text: child.text })"
                          style="color: white"
                          class="subheading footer-hover"
                          :href="child.uri"
                          :target="child.uri.includes('http') ? '_blank' : ''"
                        >
                          {{ child.text }}
                        </a>
                      </v-card-text>
                    </v-card>
                  </div>
                </template>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div style="background: #fec528">
        <v-row wrap>
          <v-container style="align-self: center; padding: 8px 16px" class="tab-view">
            <v-row class="tab-view" align="center" justify="space-between">
              <v-col cols="auto">
                <v-row
                  wrap
                  class="tab-view"
                  style="min-width: fit-content"
                  :style="xs ? 'display: grid; grid-template-columns: repeat(2, 1fr);' : ''"
                >
                  <a
                    @click="
                      asuoDataLayerClick('FooterComponent', '3', {
                        text: link.title
                      })
                    "
                    class="pr-4 font-weight-bold"
                    style="color: black; align-self: center"
                    :class="xs ? 'py-2' : ''"
                    :href="link.href"
                    target="_blank"
                    v-for="link in eaFooterLinkAndContent.innovationBanner"
                    :key="link.title"
                    >{{ link.title }}</a
                  >
                </v-row>
              </v-col>
              <v-col cols="auto">
                <img style="height: 80px" class="d-none d-md-flex ml-auto" src="../assets/images/innovation-logo.png" />
              </v-col>
            </v-row>
            <img
              style="height: 80px"
              class="d-md-none"
              src="../assets/images/innovation-logo.png"
              :style="xs ? 'width: 100%;' : ''"
            />
          </v-container>
        </v-row>
      </div>

      <v-container style="padding: 16px">
        <v-row wrap class="tab-view" :style="xs ? 'display: grid; grid-template-columns: repeat(2, 1fr);' : ''">
          <a
            @click="asuoDataLayerClick('FooterComponent', '4', { text: link.title })"
            style="color: #191919"
            :href="link.href"
            target="_blank"
            v-for="link in eaFooterLinkAndContent.trademarkFooter"
            :key="link.title"
            class="pr-4"
            :class="xs ? 'py-2' : ''"
            >{{ link.title }}</a
          >
        </v-row>
      </v-container>
    </footer>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useDisplay } from 'vuetify';
import { useUserStore } from '@/stores/user';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { Helper } from '../mixins/helpers.js';

export default defineComponent({
  setup() {
    const { xs } = useDisplay();
    return { xs };
  },
  data() {
    return {
      isOpen: true,
      starbucksUndergradImg: new URL('../assets/images/130509-Undergrad-Graduation-2231 copy.png', import.meta.url)
        .href,
      undergradImg: new URL('../assets/images/130509-Undergrad-Graduation-2231 copy.png', import.meta.url).href,
      route: '',
      eaBlackFooterContent: [
        {
          title: 'How it Works',
          children: [
            { text: 'Explore ASU degrees', uri: 'https://ea.asu.edu/how-it-works/explore-degree-options/' },
            { text: 'Pricing', uri: 'https://ea.asu.edu/how-it-works/pricing/' },
            { text: 'International learners', uri: 'https://ea.asu.edu/how-it-works/international-learners/' },
            { text: 'GPA Calculator', uri: 'https://ea.asu.edu/gpa-calculator/' }
          ]
        },
        {
          title: 'Courses',
          children: [
            { text: 'Most popular', uri: 'https://ea.asu.edu/courses/most-popular/' },
            { text: 'Degree pathways', uri: 'https://ea.asu.edu/courses/degree-pathways/' },
            { text: 'Certificates', uri: 'https://ea.asu.edu/courses/certificates/' },
            { text: 'Course catalog', uri: 'https://courses.ea.asu.edu/' }
          ]
        },
        {
          title: 'Help center',
          children: [
            { text: 'FAQs', uri: 'https://ea.asu.edu/help-center/faqs/' },
            { text: 'Proctoring', uri: 'https://ea.asu.edu/help-center/proctoring/' },
            { text: 'Accessibility', uri: 'https://ea.asu.edu/help-center/accessibility/' },
            { text: 'Technical Requirements', uri: 'https://ea.asu.edu/technical-requirements/' },
            { text: 'Terms of Use', uri: 'https://ea.asu.edu/terms-of-use/' }
          ]
        }
      ],
      ulcBlackFooterContent: [
        {
          title: 'How it works',
          children: [
            { text: 'Pricing', uri: 'https://ulc.asu.edu/how-to-enroll/pricing/' },
            { text: 'How to get college credit', uri: 'https://ulc.asu.edu/how-to-enroll/how-to-get-college-credit/' },
            { text: 'International learners', uri: 'https://ulc.asu.edu/how-to-enroll/international-learners/' },
            { text: 'Pay with 529', uri: 'https://ulc.asu.edu/how-it-works/pay-with-529/' }
          ]
        },
        {
          title: 'Explore courses',
          children: [
            { text: 'Most popular', uri: 'https://ulc.asu.edu/explore-courses/most-popular/' },
            { text: 'For high school students', uri: 'https://ulc.asu.edu/explore-courses/for-high-school-students/' },
            { text: 'By interests and careers', uri: 'https://ulc.asu.edu/explore-courses/by-interests-and-careers/' },
            { text: 'Foundations certificates', uri: 'https://ulc.asu.edu/explore-courses/foundations-certificates/' },
            { text: 'Degree pathways', uri: 'https://ulc.asu.edu/degree-pathways/' },
            { text: 'Arizona diploma seals', uri: 'https://ulc.asu.edu/arizona-diploma-seals/' },
            { text: 'Course catalog', uri: 'https://courses.ulc.asu.edu/' }
          ]
        },
        {
          title: 'Help center',
          children: [
            { text: 'FAQs', uri: 'https://ulc.asu.edu/help-center/faqs/' },
            { text: 'Proctoring', uri: 'https://ulc.asu.edu/help-center/proctoring/' },
            { text: 'Accessibility', uri: 'https://ulc.asu.edu/help-center/accessibility/' },
            { text: 'Technical Requirements', uri: 'https://ulc.asu.edu/technical-requirements/' },
            { text: 'Terms of Use', uri: 'https://ulc.asu.edu/terms-of-use/' }
          ]
        },
        {
          title: 'ASU Universal Pathways',
          children: [{ text: 'Transfer credits', uri: 'https://ulc.asu.edu/asu-universal-pathways/transfer-credits/' }]
        }
      ],
      eaFooterLinkAndContent: {
        innovationBanner: [
          {
            title: 'Maps and Locations',
            href: 'https://www.asu.edu/about/locations-maps'
          },
          {
            title: 'Jobs',
            href: 'https://cfo.asu.edu/applicant'
          },
          {
            title: 'Directory',
            href: 'https://search.asu.edu/'
          },
          {
            title: 'Contact ASU',
            href: 'https://www.asu.edu/about/contact'
          },
          {
            title: 'My ASU',
            href: 'https://my.asu.edu/'
          }
        ],
        trademarkFooter: [
          {
            title: 'Copyright and Trademark',
            href: 'https://www.asu.edu/about/copyright-trademark'
          },
          {
            title: 'Accessibility',
            href: 'https://accessibility.asu.edu/report'
          },
          {
            title: 'Privacy',
            href: 'https://www.asu.edu/about/privacy'
          },
          {
            title: 'Terms of Use',
            href: 'https://www.asu.edu/about/terms-of-use'
          },
          {
            title: 'Emergency',
            href: 'https://cfo.asu.edu/emergency'
          }
        ]
      },
      defaultPhone: '844-448-7707',
      defaultEmail: 'ulcourses@asu.edu'
    };
  },

  mixins: [Helper, DataLayerMixin],

  computed: {
    isEligibleToCreateLearner() {
      const userStore = useUserStore();
      return userStore.welcomePageData.isEligibleForSignUp ? this.undergradImg : this.starbucksUndergradImg;
    },
    isEligibleCreateLearner() {
      const userStore = useUserStore();
      return userStore.welcomePageData.isEligibleForSignUp;
    },
    telephone() {
      const userStore = useUserStore();
      return (userStore.welcomePageData || {}).servicePhoneNumber || this.defaultPhone;
    },
    email() {
      const userStore = useUserStore();
      return (userStore.welcomePageData || {}).serviceEmail || this.defaultEmail;
    },
    dial() {
      const userStore = useUserStore();
      return 'tel:' + ((userStore.welcomePageData || {}).servicePhoneNumber || this.defaultPhone);
    },
    href() {
      const userStore = useUserStore();
      return 'mailto:' + ((userStore.welcomePageData || {}).serviceEmail || this.defaultEmail);
    },
    windowWidth() {
      return window.innerWidth;
    },
    shouldDisplayUndergradImg() {
      let route = this.$route.name;
      // Graduation photo removed from the login/welcome page redesign
      if (route == 'Registerv2' || route == 'ConfirmRegistrationv2' || route == 'register') {
        return true;
      } else {
        return false;
      }
    },
    showUlcHeaderFooter() {
      // Check if the partner name  for ULC header and footer
      const partnerName = this.$conn.getPartnerName();
      if (partnerName === 'accelerate' || partnerName === 'kipp' || partnerName === 'hs4cc') {
        return true;
      }
      return Helper.methods.isUlcPartner();
    }
  },

  methods: {
    toggle: function () {
      this.isOpen = !this.isOpen;
    },
    navigateTo(url) {
      window.open(url, '_blank');
    }
  },

  created() {
    this.route = this.$route.name;
  }
});
</script>
